// extracted by mini-css-extract-plugin
module.exports = {"taskItem":"task_item_taskItem__Klwwy","checkboxWrap":"task_item_checkboxWrap__gqGVc"};